import { ref } from 'vue'
import { getImkey, getImtoken, getOldMessage } from '@/services/picDetails'
import { Random } from 'mockjs'
import dayjs from 'dayjs'
import { useStore } from '@gx-vuex'
import { isJSONStr } from '@/utils/validate'
import * as RongIMLib from '@rongcloud/imlib-next'
import { getChinaTimeUix } from '@/utils/util'

export function useChat() {
  const store = useStore()
  const contentId = document.querySelector('body').getAttribute('data-id')
  const status = ref<'wait' | 'running' | 'end' | 'cancel' | 'paused'>(document.querySelector('body')
    .getAttribute('data-live-status') as any)

  const imkey = ref('')
  const imToken = ref('')

  const momunt = ref(false)
  const needSwitch = ref(false)

  const startChat = async () => {
    if (status.value === 'running') {
      try {
        const response = await getImkey()
        if (response) imkey.value = response.data
        const id = Random.id()
        const responses = await getImtoken({
          userName: id,
          userId: id
        })
        if (response) imToken.value = responses.data

        await getMessageList()
        if (response) startIm()
      } catch (err) {}
    } else {
      getMessageList()
    }
  }

  const startIm = () => {
    RongIMLib.init({ appkey: imkey.value })
    RongIMLib.connect(imToken.value).then((res) => {
      if (res.code === 0) {
        // @ts-ignore
        RongIMLib.joinChatRoom(mLive.roomId, {
          count: 1
        }).then(res => {
          console.log(res)
          // 加入聊天室成功
          if (res.code === RongIMLib.ErrorCode.SUCCESS) {
            const Events = RongIMLib.Events
            const listener = (evt) => {
              const data: {
                content: { content: string }
              }[] = evt.messages
              const lastSwitch = data?.filter((_, index) => index === data?.length - 1)?.[0]
              const lastContent: {
                data: string;
                imMessageTypeEnum: string;
                sender: {
                  name: string;
                  senderAvatarUrl: string;
                };
                pictureUrls: string[];
                id: string;
                date: string;
                text: string;
              } = isJSONStr(lastSwitch.content?.content)
                ? JSON.parse(lastSwitch.content?.content)
                : null

              if (lastContent) {
                if (lastContent.imMessageTypeEnum === 'STOP_LIVE') {
                  setTimeout(() => {
                    location.reload()
                  }, 2000)
                }
                if (lastContent.data) {
                  const mesage: any = isJSONStr(lastContent.data)
                    ? JSON.parse(lastContent.data)
                    : ''
                  needSwitch.value = !!mesage?.showPad
                }
              }

              data?.forEach(item => {
                const content: {
                  data: string;
                  sender: {
                    name: string;
                    senderAvatarUrl: string;
                  };
                  pictureUrls: string[];
                  id: string;
                  date: string;
                  text: string;
                } = isJSONStr(item.content?.content) ? JSON.parse(item.content?.content) : null

                if (content) {
                  if (store.global.chatData.length === 0) {
                    nextTick(() => {
                      store.global.setGlobalData({
                        scrollNum: store.global.scrollNum + 1
                      })
                    })
                  }
                  if (momunt.value) {
                    store.global.addChatData({
                      id: content.id,
                      pictureUrls: content.pictureUrls,
                      name: content.sender?.name,
                      content: content.text,
                      receivedTime: content.date,
                      avatar: content.sender?.senderAvatarUrl
                    }, 'unshift')
                  } else {
                    momunt.value = true
                  }
                }
              })
              store.global.filterChatData()
            }
            RongIMLib.addEventListener(Events.MESSAGES, listener)
          } else {
            console.log(res.code, res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    })
  }

  const getMessageList = async () => {
    const response = await getOldMessage({
      liveId: contentId,
      // @ts-ignore
      mLiveId: mLive.id,
      pageNum: 1,
      pageSize: 100,
      dateTimeStamp: dayjs().valueOf()
    })

    if (response) {
      const data: {
        barrageResponses: {
          id: string;
          auditStatus: string;
          data: string;
          time: string;
          senderName: string;
          senderUserName: string;
          senderAvatarUrl: string;
        }[]
      } = response.data || {}
      data?.barrageResponses?.filter(item => item.auditStatus === 'pass')?.forEach(item => {
        const content: {
          pictureUrls: string[];
          text: string;
        } = isJSONStr(item.data) ? JSON.parse(item?.data) : null
        store.global.addChatData({
          id: item.id,
          pictureUrls: content.pictureUrls,
          name: item.senderName || item.senderUserName,
          content: content.text,
          receivedTime: dayjs(getChinaTimeUix(item.time)),
          avatar: item?.senderAvatarUrl
        })
      })
    }
  }

  return {
    needSwitch,
    startChat
  }
}
